import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// Types
import MediaFormats from 'types/MediaFormats';
// Components
import Accordion from 'components/Accordion';
import ImageUpload from 'components/ImageUpload';
import { Input } from 'components/Controls';
// i18next
import { useTranslation } from 'react-i18next';

const SectionCallToAction:FC = () => {
  const { t } = useTranslation();

  const { control } = useFormContext();

  return (
    <div react-scroll="callToAction">
      <Accordion label={t('labels.callToAction')} icon="call_to_action">
        <div className="w-full">
          <div className="mb-4">
            <Controller
              control={control} name="callToActionImageUrl"
              render={({ field }) => (
                <ImageUpload
                  {...field}
                  className="sm:w-1/3"
                  format={MediaFormats.CTA}
                  label="pages.groupForm.callToActionImageLabel"
                />
              )}
            />
          </div>
          <Controller
            control={control} name="callToActionLinkUrl"
            render={({ field: { value, onChange } }) => (
              <Input
                id="callToActionLinkUrl" name="callToActionLinkUrl" value={value || ''}
                placeholder={t('pages.groupForm.callToActionUrlLabel')}
                helperText={t('pages.groupForm.callToActionUrlHint')}
                onChange={onChange}
              />
            )}
          />
          <Controller
            control={control} name="callToActionButtonText"
            render={({ field: { value, onChange } }) => (
              <Input
                id="callToActionButtonText" name="callToActionButtonText" value={value || ''}
                placeholder={t('pages.groupForm.callToActionButtonTextLabel')}
                onChange={onChange}
              />
            )}
          />
        </div>
      </Accordion>
    </div>
  )
}

export default SectionCallToAction;
